export default __webpack_public_path__ + "static/media/DAI.e.849478a7.png";